import Seo from "@/components/site/Seo";
import { PageHero, Reveal } from "@/components/site/kit";
import { TeamCard } from "@/components/site/cards";
import useFetch from "@/hooks/useFetch";
import { Skeleton } from "@/components/ui/skeleton";

export default function Teams() {
  const { data: teams, loading } = useFetch("/teams", []);
  return (
    <>
      <Seo title="Teams" description="The 12 planned franchises of the Telangana–Andhra T10 League. Team identities will be announced once officially confirmed." />
      <PageHero testid="teams-hero" eyebrow="Teams" title="12 Franchises. Two States. One League." image="/images/street-bowler.jpg">
        Franchise names, identities and owners will be revealed as they are officially confirmed.
      </PageHero>
      <section className="container-x py-20">
        <div data-testid="teams-grid" className="grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-3 lg:grid-cols-4">
          {loading && Array.from({ length: 12 }).map((_, i) => <Skeleton key={i} className="h-72 rounded-md bg-[#112240]" />)}
          {(teams || []).map((t, i) => <Reveal key={t.id} delay={(i % 4) * 0.05}><TeamCard team={t} /></Reveal>)}
        </div>
      </section>
    </>
  );
}
